import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class DealersApi {
  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source();

    return Request.get('/dealers', {
      params: {
        ...options,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async getConfig() {
    return Request.get('/dealers/config');
  }

  static async fetchOne(id) {
    return Request.get(`/dealers/${id}`);
  }

  static async update(data) {
    return Request.put(`/c/dealers/${data.id}`, data);
  }

  static async remove(data) {
    return Request.delete(`/c/dealers/${data.id}`);
  }

  static async create(data) {
    return Request.post(`/c/dealers`, data);
  }

  static async sync() {
    return Request.post(`/c/dealers/sync`);
  }

  static async updateCity(data) {
    return Request.put(`/c/dealers/cities/${data.id}`, data);
  }

  static async removeCity(data) {
    return Request.delete(`/c/dealers/cities/${data.id}`);
  }

  static async createCity(data) {
    return Request.post(`/c/dealers/cities`, data);
  }
}
